import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CustomTable from "../components/Shared/CustomTable";
import LabelComponent from "../components/Shared/LabelComponent";
import LIstDetailCard from "../components/Shared/LIstDetailCard";
import { Dialog } from "primereact/dialog";

function InvoiceDetails({ visible, onHide, data, type, cancel }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const listData = (order) => [
    { label: "Client Name", value: order?.ClientName },
    { label: "Client Code", value: order?.ClientCode },
    { label: "Order ID", value: order?.ClientOrderID },
    { label: "Order Date", value: formatDate(order?.OrderDate) },
    { label: "Delivery Date", value: formatDate(order?.DeliveryDate) },
    { label: "Store", value: order?.StoreName },
    { label: "Address", value: order?.Address },
    { label: "Phone", value: order?.FirstPhone || order?.Phone || "-" },
    { label: "Sales Person", value: order?.SalesPersonName },
    { label: "Total Price", value: formatCurrency(order?.TotalPrice) },
    { label: "Net Price", value: formatCurrency(order?.NetPrice) },
    { label: "Unpaid Amount", value: formatCurrency(order?.UnpaidAmount) },
    { label: "Client Balance", value: formatCurrency(order?.ClientBalance) },
    { label: "Invoice ID", value: order?.InvoiceId || "-" },
    { label: "Local Serial", value: order?.LocalSerial },
    { label: "Status", value: order?.Paid ? "Paid" : "Unpaid" },
    { label: "Comment", value: order?.Comment || "-" },
  ];
  const GallerylistData = (invoice) => [
    { label: "Customer Name", value: invoice?.CustomerName },
    { label: "Customer ID", value: invoice?.CustomerID },
    { label: "Order ID", value: invoice?.CustomerOrderID },
    { label: "Order Date", value: formatDate(invoice?.OrderDate) },
    { label: "Gallery", value: invoice?.GalleryName },
    { label: "Gallery Address", value: invoice?.GalleryAddress },
    {
      label: "Phone",
      value: invoice?.Mobile || invoice?.Phones || invoice?.Phone2 || "-",
    },
    { label: "Sales Person", value: invoice?.SalesPerson },
    { label: "Cashier", value: invoice?.Cashier },
    { label: "Total Price", value: formatCurrency(invoice?.TotalPrice) },
    { label: "Paid Amount", value: formatCurrency(invoice?.PaidAmount) },
    { label: "Unpaid Amount", value: formatCurrency(invoice?.UnpaidAmount) },
    { label: "Balance", value: formatCurrency(invoice?.Balance) },
    { label: "Invoice ID", value: invoice?.InvoiceId || "-" },
    { label: "Local Serial", value: invoice?.LocalSerial },
    { label: "Status", value: invoice?.Paid ? "Paid" : "Unpaid" },
    { label: "Insurance Company", value: invoice?.InsuranceCompanyName || "-" },
    {
      label: "Insurance Customer",
      value: invoice?.InsuranceCustomerName || "-",
    },
    { label: "Policy Number", value: invoice?.PolicyNo || "-" },
  ];

  const NewGalleryListData = (invoice) => [
    {
      label: "Approve Amount",
      value: formatCurrency(invoice?.Approveamount),
    },
    {
      label: "Total Price",
      value: formatCurrency(invoice?.TotalPrice),
    },
    {
      label: "Deductible",
      value: formatCurrency(invoice?.Deductible),
    },
  ];
  const RevokeGallerylistData = (revoke) => [
    { label: "Customer Name", value: revoke?.CustomerName },
    { label: "Customer ID", value: revoke?.CustomerID },
    { label: "Order ID", value: revoke?.CustomerOrderID },
    { label: "Order Serial", value: revoke?.CustomerOrderSerial },
    { label: "Revoke Date", value: formatDate(revoke?.RevokeDate) },
    { label: "Gallery", value: revoke?.GalleryName },
    { label: "Gallery Address", value: revoke?.GalleryAddress },
    {
      label: "Phone",
      value: revoke?.Mobile || revoke?.Phones || revoke?.Phone2 || "-",
    },
    { label: "Sales Person", value: revoke?.SalesPersonName },
    { label: "Cashier", value: revoke?.EmployeeName },
    {
      label: "Total Revoke Amount",
      value: formatCurrency(revoke?.RevokeAmountBeforeDiscount),
    },
    { label: "Discount", value: formatCurrency(revoke?.Discount) },
    { label: "Net Revoke Amount", value: formatCurrency(revoke?.RevokeAmount) },
    { label: "Invoice ID", value: revoke?.InvoiceId || "-" },
    { label: "Local Serial", value: revoke?.LocalSerial },
    { label: "Status", value: revoke?.Paid ? "Paid" : "Unpaid" },
    { label: "Revoke Payment No", value: revoke?.RevokePaymentNo },
    { label: "Currency", value: revoke?.CurrencyName },
    { label: "Transaction Year", value: revoke?.TransYear },
    { label: "Transaction Type", value: revoke?.TransType },
    { label: "Search Serial", value: revoke?.SearchSerial },
    { label: "Receipt No", value: revoke?.ReceiptNo },
    { label: "Comments", value: revoke?.Comments || "-" },
  ];
  const RevokeStoreListData = (revoke) => [
    { label: "Client Name", value: revoke?.ClientName },
    { label: "Client Code", value: revoke?.ClientID },
    { label: "Order ID", value: revoke?.ClientOrderID },
    { label: "Revoke Date", value: formatDate(revoke?.RevokeDate) },
    { label: "Store ID", value: revoke?.StoreID },
    { label: "Address", value: revoke?.ClientAddress || "-" },
    {
      label: "Phone",
      value: revoke?.ClientPhone || revoke?.ReferencePhone || "-",
    },
    { label: "Sales Person", value: revoke?.ReferenceName || "-" },
    { label: "Revoke Amount", value: formatCurrency(revoke?.RevokeAmount) },
    { label: "Invoice ID", value: revoke?.InvoiceId || "-" },
    { label: "Local Serial", value: revoke?.LocalSerial },
    { label: "Status", value: revoke?.Status === "1" ? "Paid" : "Unpaid" },
    { label: "Comment", value: revoke?.Notes || "-" },
    { label: "Revoke Reason", value: revoke?.RevokeReason || "-" },
    { label: "Revoke By", value: revoke?.RevokeBy || "-" },
    {
      label: "Revoke Time",
      value: revoke?.RevokeTime ? formatDate(revoke?.RevokeTime) : "-",
    },
  ];

  const columnsData = [
    { field: "ProductCode", header: t("Code") },
    { field: "Description", header: t("Description") },
    { field: "Quantity", header: t("Qty") },
    {
      header: t("Unit Price"),
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        return `${unitPrice.toFixed(2)} SAR`;
      },
    },
    {
      header: "Discount (%)",
      body: (rowData) => `${(rowData?.Discount ?? 0).toFixed(2)} %`,
    },
    {
      header: "Client Discount (%)",
      body: (rowData) => `${(rowData?.ClientDiscount ?? 0).toFixed(2)} %`,
    },
    {
      header: "Total",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        return `${(unitPrice * qty).toFixed(2)} SAR`;
      },
    },
    {
      header: "Discount Amount",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        const discount = rowData?.Discount ?? 0;
        return `${((unitPrice * qty * discount) / 100).toFixed(2)} SAR`;
      },
    },
    {
      header: "After Discount",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        const discount = rowData?.Discount ?? 0;
        return `${(
          unitPrice * qty -
          (unitPrice * qty * discount) / 100
        ).toFixed(2)} SAR`;
      },
    },
    {
      header: "Client Discount Amount",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        const discount = rowData?.Discount ?? 0;
        const clientDiscount = rowData?.ClientDiscount ?? 0;

        const afterDiscount =
          unitPrice * qty - (unitPrice * qty * discount) / 100;
        return `${((afterDiscount * clientDiscount) / 100).toFixed(2)} SAR`;
      },
    },
    {
      header: "Total Discount",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        const discount = rowData?.Discount ?? 0;
        const clientDiscount = rowData?.ClientDiscount ?? 0;

        const discountAmount = (unitPrice * qty * discount) / 100;
        const afterDiscount = unitPrice * qty - discountAmount;
        const clientDiscountAmount = (afterDiscount * clientDiscount) / 100;

        return `${(discountAmount + clientDiscountAmount).toFixed(2)} SAR`;
      },
    },
    {
      header: "Net Price",
      body: (rowData) => {
        const unitPrice = rowData?.UnitPrice ?? rowData?.Unitprice ?? 0;
        const qty = rowData?.Quantity ?? 0;
        const discount = rowData?.Discount ?? 0;
        const clientDiscount = rowData?.ClientDiscount ?? 0;

        const discountAmount = (unitPrice * qty * discount) / 100;
        const afterDiscount = unitPrice * qty - discountAmount;
        const clientDiscountAmount = (afterDiscount * clientDiscount) / 100;

        const netPrice =
          unitPrice * qty - (discountAmount + clientDiscountAmount);
        return `${netPrice.toFixed(2)} SAR`;
      },
    },
  ];

  const galleryColumnsData = [
    { field: "ProductCode", header: t("Code") },
    { field: "Description", header: t("Description") },
    { field: "Quantity", header: t("Qty") },
    {
      header: t("Unit Price"),
      body: (rowData) =>
        `${rowData?.UnitPrice.toFixed(2) || rowData?.Unitprice.toFixed(2)} SAR`,
    },
    {
      header: "Real Discount",
      body: (rowData) => `${rowData?.realDiscount.toFixed(2)} SAR`,
    },
    {
      header: t("Base Amount"),
      body: (rowData) =>
        `${
          rowData?.Quantity.toFixed(2) *
          (rowData?.UnitPrice.toFixed(2) || rowData?.Unitprice.toFixed(2))
        } SAR`,
    },
    {
      header: t("Net Amount"),
      body: (rowData) =>
        `${(
          rowData?.Quantity * (rowData?.UnitPrice || rowData?.Unitprice) -
          rowData?.realDiscount
        ).toFixed(2)} SAR`,
    },
    // {
    //   header: t("Total"),
    //   body: (rowData) =>
    //     `${rowData?.TotalPrice.toFixed(2) || rowData?.TPrice.toFixed(2)} SAR`,
    // },
    // {
    //   header: t("Retail Price"),
    //   body: (rowData) => `${rowData?.RetailPrice.toFixed(2)} SAR`,
    // },
    // {
    //   header: t("Cost Price"),
    //   body: (rowData) => `${rowData?.CostPrice.toFixed(2)} SAR`,
    // },
  ];
  const revokeColumnsData = [
    { field: "ProductCode", header: t("Code") },
    { field: "Description", header: t("Description") },
    { field: "Quantity", header: t("Qty") },
    {
      header: t("Unit Price"),
      body: (rowData) => `${rowData?.Unitprice.toFixed(2)} SAR`,
    },
    {
      header: t("Total"),
      body: (rowData) => `${rowData?.TPrice.toFixed(2)} SAR`,
    },
    {
      header: t("Retail Price"),
      body: (rowData) => `${rowData?.RetailPrice.toFixed(2)} SAR`,
    },
    {
      header: t("Cost Price"),
      body: (rowData) => `${rowData?.CostPrice.toFixed(2)} SAR`,
    },
  ];

  const formatCurrency = (value) => {
    return value?.toLocaleString("en-SA", {
      style: "currency",
      currency: "SAR",
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const renderHeader = () => {
    return (
      <div className="flex gap-3">
        <span className="text-xl font-bold">Invoice Details</span>
      </div>
    );
  };

  return (
    <Dialog
      header={renderHeader}
      visible={visible}
      onHide={onHide}
      style={{ width: "90vw" }}
      breakpoints={{ "960px": "75vw", "640px": "90vw" }}
      className="p-fluid"
    >
      <div className="grid grid-cols-1 gap-4 mb-6">
        <LIstDetailCard
          listData={
            type === "gallery"
              ? GallerylistData(data?.invoice)
              : type === "revokeGallery"
              ? RevokeGallerylistData(data?.revoke)
              : type === "revokeStore"
              ? RevokeStoreListData(data?.revoke)
              : listData(data?.order)
          }
        />
      </div>
      {type === "gallery" && (
        <div className="grid grid-cols-1 gap-2 mb-6">
          <h6 className="font-semibold text-[18px]">
            Insurance Calculations From NetWave
          </h6>
          <LIstDetailCard
            listData={
              type === "gallery"
                ? NewGalleryListData(data?.invoice)
                : type === "revokeGallery"
                ? RevokeGallerylistData(data?.revoke)
                : type === "revokeStore"
                ? RevokeStoreListData(data?.revoke)
                : listData(data?.order)
            }
          />
        </div>
      )}
      <div>
        <h6 className="mb-2 font-semibold text-[18px]">Item Details</h6>
        <CustomTable
          data={data?.details}
          columns={
            type === "revokeGallery"
              ? revokeColumnsData
              : type === "gallery"
              ? galleryColumnsData
              : columnsData
          }
          rows={data?.details?.length}
        />
      </div>
    </Dialog>
  );
}

export default InvoiceDetails;
